import { Controller, useFormContext } from 'react-hook-form';
import { RadioGroup } from '@mui/material';

interface IRadioButtonGroupProps {
  name: string;
  label: string;
  children: {};
}

export function RadioButtonGroup(props: IRadioButtonGroupProps) {
  const { name, label, children } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <RadioGroup aria-label={label} {...field} row>
          {children}
        </RadioGroup>
      )}
    />
  );
}
